import { LoadableAfterPaint } from '@confluence/loadable';

export const EndOfTrialModalContainerWithErrorBoundaryLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EndOfTrialModalContainerWithErrorBoundary" */ './index'
			)
		).EndOfTrialModalContainerWithErrorBoundary,
});
